import type * as lazyIndex from "./lazyIndex";
import { LazyAction, LazyModule } from "owa-bundling";

const lazyModule: LazyModule<typeof lazyIndex> = new LazyModule<typeof lazyIndex>(() => import(/* webpackChunkName: "WorkloadScenarioSettings"*/ "./lazyIndex"), { name: "WorkloadScenarioSettings" });

export const lazyLoadWorkloadScenarioSettings: LazyAction<typeof lazyIndex.loadWorkloadScenarioSettings, typeof lazyModule> = new LazyAction(lazyModule, m => m.loadWorkloadScenarioSettings);
